import React from 'react';
import { Button, Card, Chip, CircularProgress, Stack, Typography } from '@mui/material';

const AttentionCameraList = ({ cameras, onWatchLive, loadingCameraId }) => (
  <Card sx={{ p: 3, borderRadius: '12px !important' }}>
    <Typography variant="subtitle2" color="text.secondary" gutterBottom>
      Cameras needing attention
    </Typography>
    <Stack spacing={1.5}>
      {cameras.map((camera) => {
        const isBusy = loadingCameraId === camera.id;
        return (
          <Stack key={camera.id} spacing={0.5}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="body1" fontWeight={600}>
                {camera.name || `Camera ${camera.id}`}
              </Typography>
              <Chip
                size="small"
                color={camera.isReachable ? 'warning' : 'default'}
                label={camera.isReachable ? 'Awaiting motion' : 'Offline'}
              />
            </Stack>
            <Typography variant="body2" color="text.secondary">
              Last heartbeat:{' '}
              {camera.lastPing ? new Date(camera.lastPing).toLocaleString() : 'No heartbeat recorded'}
            </Typography>
            <Stack direction="row" spacing={1} sx={{ pt: 1 }}>
              <Button
                variant="contained"
                size="small"
                onClick={() => onWatchLive(camera)}
                disabled={isBusy}
                startIcon={isBusy ? <CircularProgress size={14} color="inherit" /> : undefined}
              >
                Watch live
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={() => window.open(`/cameras?cameraId=${camera.id}`, '_blank')}
              >
                View details
              </Button>
            </Stack>
          </Stack>
        );
      })}
    </Stack>
  </Card>
);

export default AttentionCameraList;
